/* DHC v931 — retailer-style product page */
(function(){
  'use strict';

  function initQuantity(root){
    root.querySelectorAll('.dhc-pdp-v931').forEach(function(pdp){
      if(pdp.dataset.dhcQtyReady==='1') return;
      pdp.dataset.dhcQtyReady='1';
      var input=pdp.querySelector('[data-dhc-pdp-qty]');
      var minus=pdp.querySelector('[data-dhc-pdp-qty-minus]');
      var plus=pdp.querySelector('[data-dhc-pdp-qty-plus]');
      if(!input) return;
      function set(v){
        var min=Math.max(1,Number(input.min)||1);
        input.value=Math.max(min,Number(v)||min);
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      if(minus) minus.addEventListener('click',function(){set(Number(input.value||1)-1)});
      if(plus) plus.addEventListener('click',function(){set(Number(input.value||1)+1)});
    });
  }

  function initMedia(root){
    root.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
      if(gallery.dataset.dhcV931MediaReady==='1') return;
      gallery.dataset.dhcV931MediaReady='1';
      var items=[].slice.call(gallery.querySelectorAll('[data-media-id]'));
      var thumbs=[].slice.call(gallery.querySelectorAll('[data-product-thumb]'));
      var pdp=gallery.closest('.dhc-pdp-v931');
      var variantSelect=pdp && pdp.querySelector('[data-dhc-variant-select]');

      function pauseInactive(active){
        items.forEach(function(item){
          if(item===active) return;
          item.querySelectorAll('video').forEach(function(v){try{v.pause()}catch(e){}});
          item.querySelectorAll('iframe').forEach(function(frame){
            try{frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}','*')}catch(e){}
          });
        });
      }

      function activateMedia(id){
        id=String(id||'');
        if(!id) return false;
        var active=null;
        items.forEach(function(item){
          var on=String(item.getAttribute('data-media-id')||'')===id;
          item.classList.toggle('is-active',on);
          if(on) active=item;
        });
        if(!active) return false;
        thumbs.forEach(function(t){
          t.classList.toggle('is-active',String(t.getAttribute('data-product-thumb')||'')===id);
        });
        pauseInactive(active);
        return true;
      }

      thumbs.forEach(function(btn){
        btn.addEventListener('click',function(){
          activateMedia(btn.getAttribute('data-product-thumb'));
        });
      });

      if(variantSelect){
        variantSelect.addEventListener('change',function(){
          var opt=variantSelect.options[variantSelect.selectedIndex];
          if(!opt) return;
          activateMedia(opt.getAttribute('data-media-id'));
        });
        var initial=variantSelect.options[variantSelect.selectedIndex];
        if(initial) activateMedia(initial.getAttribute('data-media-id'));
      }
    });
  }

  function getProductContext(){
    var node=document.querySelector('[data-dhc-product-json]');
    if(!node) return null;
    try{return JSON.parse(node.textContent)}catch(e){return null}
  }

  function initJack(root){
    root.querySelectorAll('[data-dhc-product-jack]').forEach(function(btn){
      if(btn.dataset.dhcV931JackReady==='1') return;
      btn.dataset.dhcV931JackReady='1';

      btn.addEventListener('click',function(e){
      if(btn.hasAttribute('data-dhc-size-help-v193'))return;
        e.preventDefault();
        e.stopPropagation();

        var ctx=getProductContext()||{};
        window.DHCProductContext=ctx;

        var widget=document.querySelector('[data-dhc-support]');
        if(widget){
          try{widget.dataset.dhcProductContext=JSON.stringify(ctx)}catch(_){}
        }

        if(typeof window.DHCOpenJack==='function'){
          try{window.DHCOpenJack()}catch(_){}
        }

        setTimeout(function(){
          var w=document.querySelector('[data-dhc-support]');
          var form=w && w.querySelector('[data-support-form]');
          var input=form && form.elements && form.elements.message;
          if(!input) return;
          var title=ctx.title || btn.getAttribute('data-product-title') || 'this product';
          input.setAttribute('placeholder','Ask Gus about '+title);
          try{input.focus()}catch(_){}
        },80);
      });
    });
  }

  function initRecommendations(root){
    root.querySelectorAll('[data-dhc-recommendations]').forEach(function(box){
      if(box.dataset.dhcRecReady==='1') return;
      box.dataset.dhcRecReady='1';
      var url=box.getAttribute('data-url');
      if(!url) return;

      function loadRecommendations(requestUrl,allowFallback){
        return fetch(requestUrl,{headers:{'X-Requested-With':'XMLHttpRequest'}})
          .then(function(r){if(!r.ok) throw new Error('recommendations'); return r.text()})
          .then(function(html){
            var doc=new DOMParser().parseFromString(html,'text/html');
            var source=doc.querySelector('[data-dhc-recommendations-content]');
            var target=box.querySelector('[data-dhc-recommendations-content]');
            var hasProducts=!!(source && source.querySelector('.dhc-product-card'));
            if(hasProducts && target){
              target.innerHTML=source.innerHTML;
              box.classList.add('is-loaded');
              return true;
            }
            if(allowFallback){
              var fallback=box.getAttribute('data-fallback-url');
              if(fallback && fallback!==requestUrl) return loadRecommendations(fallback,false);
            }
            box.classList.add('is-empty');
            return false;
          });
      }

      loadRecommendations(url,true).catch(function(){
        var fallback=box.getAttribute('data-fallback-url');
        if(fallback && fallback!==url){
          loadRecommendations(fallback,false).catch(function(){box.classList.add('is-empty')});
        }else{
          box.classList.add('is-empty');
        }
      });
    });
  }

  function boot(root){
    root=root||document;
    initQuantity(root);
    initMedia(root);
    initJack(root);
    initRecommendations(root);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){boot(document)},{once:true});
  }else{
    boot(document);
  }
  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
})();
